import { useEffect } from 'react';
import { listenTripStatusAnalysis } from '../../channels/tripStatusAnalysisChannel';
import { useTripStatusAnalysisStore } from '../../stores/analysis/useTripStatusAnalysisStore';

export function useTripStatusAnalysisChannel() {

    useEffect(() => {

        const unsubscribe = listenTripStatusAnalysis(({ tipo, payload }) => {

            const {
                setStatus,
                setStatusBatch,
                deleteStatus
            } = useTripStatusAnalysisStore.getState();

            if (tipo === 'trip-status-analysis-upsert') {
                setStatus(payload, false);
            }

            if (tipo === 'trip-status-analysis-batch-upsert') {
                setStatusBatch(payload, false);
            }

            if (tipo === 'trip-status-analysis-delete') {
                deleteStatus(payload.date, payload.codigo, false);
            }

        });

        return unsubscribe;

    }, []);

}